export const FILTER_OPTION_RESOURCE = {
  ASSETS: 'Assets',
  CONTACTS: 'Contacts',
  CURRENCIES: 'Currencies',
  DOCUMENTS: 'Documents',
  EXPENSE_ACCOUNTS: 'ExpenseAccounts',
  LINKED_DATA_POSITIONS: 'LinkedDataPositions',
  LINKED_DATA_TRANSACTIONS: 'LinkedDataTransactions',
  INCOME_ACCOUNTS: 'IncomeAccounts',
  TAGS: 'Tags',
  TRANSACTIONS: 'Transactions',
} as const

export const FILTER_OPTION_ASSETS = {
  TYPE: 'type',
  NAME: 'name',
  TICKER: 'ticker',
  TAGS: 'tags',
  QUOTE_CURRENCY: 'quote_currency',
  CREATED_BY: 'created_by',
  UPDATED_BY: 'updated_by',
} as const

export const FILTER_OPTION_CONTACTS = {
  NAME: 'name',
  EMAIL: 'email',
  PHONE: 'phone',
  LINKED_ASSETS: 'linked_assets',
  CREATED_BY: 'created_by',
  UPDATED_BY: 'updated_by',
} as const

export const FILTER_OPTION_CURRENCIES = {
  NAME: 'name',
  TICKER: 'ticker',
} as const

export const FILTER_OPTION_DOCUMENTS = {
  DOCUMENT: 'document',
  PATH: 'path',
  ASSET: 'asset',
  CREATED_BY: 'created_by',
  UPDATED_BY: 'updated_by',
} as const

export const FILTER_OPTION_EXPENSE_ACCOUNTS = {
  ACCOUNT: 'account',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
} as const

export const FILTER_OPTION_LINKED_DATA_TRANSACTIONS = {
  CONNECTOR_NAME: 'connector_name',
  CUSTODIAN: 'custodian',
  ACCOUNT_NAME: 'account_name',
  ACCOUNT_NUMBER: 'account_number',
  ACCOUNT_TYPE: 'account_type',
  TAGS: 'tags',
  YEAR: 'year',
  QUARTER: 'quarter',
  MONTH: 'month',
  TYPE: 'type',
  ACCESS_METHOD: 'access_method',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  DESCRIPTION: 'description',
  COUNTERPARTY: 'counterparty',
  STATUS: 'status',
  ACCOUNT_TAG_NAMES: 'account_tag_names',
  ACCOUNT_TAG_VALUES: 'account_tag_values',
} as const

export const FILTER_OPTION_LINKED_DATA_POSITIONS = {
  CUSTODIAN: 'custodian',
} as const

export const FILTER_OPTION_INCOME_ACCOUNTS = {
  ACCOUNT: 'account',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
} as const

export const FILTER_OPTION_TAGS = {
  NAME: 'name',
  VALUE: 'value',
  CREATED_BY: 'created_by',
  UPDATED_BY: 'updated_by',
} as const

export const FILTER_OPTION_TRANSACTIONS = {
  TYPE: 'type',
  ACCOUNT_TO: 'account_to',
  ACCOUNT_TO_TYPE: 'account_to_type',
  ASSET_TO: 'asset_to',
  ACCOUNT_FROM: 'account_from',
  ACCOUNT_FROM_TYPE: 'account_from_type',
  ASSET_FROM: 'asset_from',
  CREATED_BY: 'created_by',
  UPDATED_BY: 'updated_by',
} as const
